import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useHostValue } from "../Contexts/HostContext";
import { Link } from 'react-router-dom';
import { filterHosts } from "../Helper/HostListSorter";
function Pagination(_a) {
  var page = _a.page;
  var state = useHostValue()[0];
  var highestPage = Math.ceil(filterHosts(state.hosts).length / 25);
  if (highestPage === 1 || page > highestPage) {
    return null;
  }
  var BackButton = null;
  var prePrevious = null;
  var Previous = null;
  var next = null;
  var nextNext = null;
  var ForwardButton = null;
  function createNumberButton(pagenum) {
    if (pagenum === 1) {
      return /*#__PURE__*/React.createElement(Link, {
        className: "c-pagination__item",
        to: "/"
      }, pagenum);
    }
    return /*#__PURE__*/React.createElement(Link, {
      className: "c-pagination__item",
      to: "/seite/".concat(pagenum, "/")
    }, pagenum);
  }
  if (page > 1) {
    var previousPage = page - 1;
    if (previousPage === 1) {
      BackButton = /*#__PURE__*/React.createElement(Link, {
        className: "c-pagination__item",
        to: '/'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'sr-only'
      }, "Zur\u00FCck zu Seite 1"), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faChevronLeft
      }));
    } else {
      BackButton = /*#__PURE__*/React.createElement(Link, {
        className: "c-pagination__item",
        to: "/seite/".concat(previousPage, "/")
      }, /*#__PURE__*/React.createElement("div", {
        className: 'sr-only'
      }, "Zur\u00FCck zu Seite ", previousPage), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faChevronLeft
      }));
    }
    Previous = createNumberButton(previousPage);
  }
  if (page >= 3) {
    prePrevious = createNumberButton(page - 2);
  }
  if (page < highestPage) {
    var nextPage = page + 1;
    ForwardButton = /*#__PURE__*/React.createElement(Link, {
      className: "c-pagination__item",
      to: "/seite/".concat(nextPage, "/")
    }, /*#__PURE__*/React.createElement("div", {
      className: 'sr-only'
    }, "Weiter zu Seite ", nextPage), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faChevronRight
    }));
    next = createNumberButton(nextPage);
  }
  if (page < highestPage - 1) {
    nextNext = createNumberButton(page + 2);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination prodwidth center gridreplace text-center push-bottom c-pagination l-container h-center"
  }, BackButton, " ", prePrevious, " ", Previous, " ", /*#__PURE__*/React.createElement("span", {
    className: 'current c-pagination__item--current'
  }, page), " ", next, " ", nextNext, " ", ForwardButton);
}
export default Pagination;